import React from 'react'
import styles from './style.module.scss'
import Navbar from '../../Components/Navbar'
import { Helmet } from 'react-helmet'
import { HeaderImg } from '../../Components/Header'
import headerImg from '../../Assets/headerImgs/abd.jpg'
import Copyrights from '../../Components/Copyrights'
import emailjs from '@emailjs/browser';

const ContactPage = () => {

  const sendEmail = async (e) => {
    e.preventDefault();

    emailjs
      .send(
        process.env.REACT_APP_EMAIL_SERVICE_ID,  // Access from .env
        process.env.REACT_APP_EMAIL_TEMPLATE_ID, // Access from .env
        {
          name: e.target.name.value,
          email: e.target.email.value,
          phone_number: e.target.phone.value,
          country: e.target.country.value,
          message: e.target.message.value,
        },
        {
          publicKey: process.env.REACT_APP_EMAIL_PUBLIC_KEY // Access from .env
        } 
      ).then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
        },
        (err) => {
          console.error('FAILED...', err);
        }
      );
  };

  return (
    <div className={styles.container}>
      <Helmet>
        <title>Contact</title>
      </Helmet>
      <Navbar active="contact" />
      <HeaderImg img={headerImg} alt="headerImg" />
      <div className={styles.contactUsCont}>
        <form className={styles.contactForm} onSubmit={sendEmail}>
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required />
          <label htmlFor="phone">Phone</label>
          <input type="tel" id="phone" name="phone" required />
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" required />
          <label htmlFor="country">Country</label>
          <input type="text" id="country" name="country" required />
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" required />
          <button type="submit">Submit</button>
        </form>
        <div className={styles.contactUsInfo}>
          <p>No. 45/05, Wennawatta , Wellampitiya ,Sri Lanka</p>
          <ul>
            <li><strong>Tel :</strong> <a href="tel:+94715358055">+94 715358055</a> , <a href="tel:+94115748312">+94 11 5748312</a></li>
            <li><strong>Hot Lines :</strong>
              <ul>
                <li><a href="tel:+94718622996">+94 718622996</a></li>
                <li><a href="tel:+94718622997">+94 718622997</a></li>
                <li><a href="tel:+94718479758">+94 718479758</a></li>
              </ul>
            </li>
            <li><strong>Fax :</strong> <a href="fax:+94112531811">+94 11 2531811</a></li>
            <li><strong>Email :</strong> <a href="mailto:wedageco@sltnet.lk">wedageco@sltnet.lk</a></li>
          </ul>
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7921.080895595623!2d79.903671!3d6.945392!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25833a281c55b%3A0x7884479fb86f61a5!2sWedage%20%26%20Co%3B%20Pvt%20Ltd!5e0!3m2!1sen!2sus!4v1734430400473!5m2!1sen!2sus"
            // width="600"
            // height="450"
            // style={{ border: 0 }}
            className={styles.map}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
      <Copyrights />
    </div>
  )
}

export default ContactPage